<template>
  <p>Selecciona el elemento que deseas agregar</p>

  <div class="list__container">
    <FormElementCard
      v-for="element in formElementOptions"
      :key="element.type"
      :element="element"
      :selected="element.type === selected?.type"
      :disabled="isDisabledByType(element.type)"
      @select="handleSelect"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { ElementType, FormElement, FormElementOption } from "@/@types/entities/forms";
import { formElementOptions } from "@/app/entities/utils/forms";

import FormElementCard from "@/app/entities/components/card/FormElementCard.vue";

const props = defineProps<{
  form: FormElement[];
}>();

const selected = ref<FormElementOption | null>(null);

const handleSelect = (element: FormElementOption) => {
  selected.value = element;
};

const isDisabledByType = (type: ElementType) => {
  const checkIfHasAtLeastOneOfType = (elementType: ElementType) =>
    props.form.some((element) => element.type === elementType);

  if ([ElementType.Pdp, ElementType.Reminder].includes(type))
    return checkIfHasAtLeastOneOfType(type);

  return false;
};

defineExpose({ selected });
</script>

<style scoped lang="sass">
p
  color: $gray-8
  font-size: 12px

.list
  &__container
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 16px 20px
</style>
